export default __webpack_public_path__ + "static/media/bookcase@2x.ddce1581.png";